import { useEffect } from 'react'

declare global {
	interface Window {
		_paq?: Array<unknown[]>
	}
}

/**
 * Boots the self-hosted Matomo tracker by pushing onto the `_paq` queue and
 * injecting `matomo.js`. Under the cookieless posture (`CONSENT_MODE=cookieless`,
 * ADR-075) the caller passes `cookieless`, which issues `disableCookies` before
 * the first page view so Matomo runs without setting any analytics cookie.
 */
export function Matomo({
	url,
	siteId,
	cookieless = false,
}: {
	url: string
	siteId: string
	cookieless?: boolean
}) {
	useEffect(() => {
		const paq = (window._paq = window._paq ?? [])
		// Must precede the first page view to take effect.
		if (cookieless) paq.push(['disableCookies'])
		paq.push(['trackPageView'])
		paq.push(['enableLinkTracking'])
		const baseUrl = url.replace(/\/?$/, '/')
		paq.push(['setTrackerUrl', `${baseUrl}matomo.php`])
		paq.push(['setSiteId', siteId])
		const script = document.createElement('script')
		script.async = true
		script.src = `${baseUrl}matomo.js`
		const first = document.getElementsByTagName('script')[0]
		first?.parentNode?.insertBefore(script, first)
	}, [url, siteId, cookieless])
	return null
}
